"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var formatting_1 = require("./formatting/formatting");
var LineFlyout_1 = require("./LineFlyout");
var styles_1 = require("./styles/styles");
var MetricDot_1 = require("./MetricDot");
var react_sizeme_1 = require("react-sizeme");
var widgets_1 = require("@tableau/widgets");
var victory_1 = require("victory");
var style = {};
// We have to define this here in order to have axis labels render in the correct font.
// Since they are SVGs, they don't inherit styles like the rest of the text elements do.
var fontFamily = 'Benton Sans';
var DetailTimeSeries = /** @class */ (function (_super) {
    __extends(DetailTimeSeries, _super);
    function DetailTimeSeries(props) {
        var _this = _super.call(this, props) || this;
        // VictoryVoronoiContainers need labels to show the labelComponent,
        // but we want to use our custom LineFlyout object, which has its
        // own label, so we're deliberately returning null while we look into
        // alternative ways to do this
        _this.renderEmptyLabel = function (point) {
            return '';
        };
        _this.handleActivated = function (points) {
            var activePoint = { timestamp: points[0].timestamp, measure: points[0].measure };
            if (_this.props.onActivated) {
                _this.props.onActivated(activePoint);
            }
            _this.setState({ currentPoint: activePoint });
        };
        _this.state = {
            currentPoint: props.data[props.data.length - 1],
        };
        return _this;
    }
    DetailTimeSeries.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_sizeme_1.SizeMe, { monitorHeight: true, monitorWidth: true }, function (_a) {
            var size = _a.size;
            return (React.createElement("div", { "data-tb-test-id": _this.props.testId, style: __assign({}, style, _this.props.style, { width: '100%', height: '100%' }) },
                React.createElement(victory_1.VictoryChart, { scale: { x: 'time', y: 'linear' }, height: size.height === null ? undefined : size.height, width: size.width === null ? undefined : size.width, padding: chartPadding, domainPadding: { x: [50, 20], y: [10, 20] }, containerComponent: React.createElement(victory_1.VictoryVoronoiContainer, { voronoiBlacklist: ['dot'], responsive: false, voronoiDimension: 'x', labels: _this.renderEmptyLabel, radius: undefined, style: {
                            labels: { fill: 'none' },
                        }, labelComponent: React.createElement(victory_1.VictoryTooltip, { dy: 20, dx: -20, flyoutComponent: React.createElement(LineFlyout_1.LineFlyout, { height: size.height === null ? 0 : size.height }) }), onActivated: _this.handleActivated }) },
                    React.createElement(victory_1.VictoryAxis, { crossAxis: false, style: {
                            tickLabels: {
                                fill: 'grey',
                                fontSize: '12px',
                                fontFamily: fontFamily,
                            },
                            axisLabel: { fill: widgets_1.TabStyles.Colors.L7 },
                        }, standalone: false, axisComponent: React.createElement("line", { style: { stroke: 'none' } }), offsetY: 30 }),
                    React.createElement(victory_1.VictoryAxis, { dependentAxis: true, crossAxis: false, axisComponent: React.createElement("line", { style: { stroke: 'none' } }), tickLabelComponent: React.createElement(victory_1.VictoryLabel, { dy: -8, dx: 40 }), tickFormat: formatting_1.formatValueAsMetricNumber, style: {
                            grid: { stroke: widgets_1.TabStyles.Colors.L7 },
                            tickLabels: {
                                fill: 'grey',
                                fontSize: '12px',
                                fontFamily: fontFamily,
                            },
                        } }),
                    React.createElement(victory_1.VictoryLine, { data: _this.props.data, x: 'timestamp', y: 'measure', style: {
                            data: {
                                stroke: styles_1.MetricBlue,
                                strokeWidth: 1.5,
                            },
                            labels: { fill: widgets_1.TabStyles.Colors.L7 },
                        } }),
                    React.createElement(victory_1.VictoryScatter, { x: 'timestamp', y: 'measure', name: 'dot', data: [_this.state.currentPoint], dataComponent: React.createElement(MetricDot_1.MetricDot, null) }))));
        }));
    };
    return DetailTimeSeries;
}(React.PureComponent));
exports.DetailTimeSeries = DetailTimeSeries;
var chartPadding = {
    top: 30,
    left: 5,
    right: 15,
    bottom: 30,
};
//# sourceMappingURL=DetailTimeSeries.js.map